import React from 'react';
import Model from '../common/models/Model';
import { Button } from '../common/Button';

interface ActiveCampaignRunningModalProps {
  isOpen: boolean;
  title: string;
  message: string;
  onClose: () => void;
}

const ActiveCampaignRunningModal: React.FC<ActiveCampaignRunningModalProps> = ({
  isOpen,
  title,
  message,
  onClose,
}) => {
  return (
    <Model
      isOpen={isOpen}
      onClose={onClose}
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 backdrop-blur-[0px]"
    >
      <div className="-m-6 w-[359px] bg-white rounded-[20px] flex flex-col px-6 py-6">
        {/* Title */}
        <h2 className="text-[16px] leading-[24px] tracking-[0.006em] font-semibold font-inter text-[#172B4D] text-left">
          {title}
        </h2>

        {/* Message */}
        <p className="mt-6 text-[14px] leading-[20px] tracking-[0.25px] font-normal font-manrope text-[#212121] text-left">
          {message}
        </p>

        {/* Button */}
        <Button
          onClick={onClose}
          className="mt-6 w-full h-[44px] rounded-full bg-[#113E53] text-white text-[14px] font-medium hover:bg-[#0e3343] transition-colors"
        >
          Close
        </Button>
      </div>
    </Model>
  );
};

export default ActiveCampaignRunningModal;
